var React = require('react');

function IconArrowOut (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.8692 5.64935L9.15878 0.0606807C9.04949 -0.0720956 8.85276 0.0123984 8.85276 0.193457V2.24545C1.28992 2.64378 0.120525 9.00497 0.000306345 12.7227C-0.0106226 12.9762 0.27353 13.0969 0.426536 12.9158C3.31178 9.54815 6.17517 9.48779 8.85276 9.49986V11.7088C8.85276 11.9019 9.07134 11.9985 9.19156 11.8536L13.8692 6.31323C14.0331 6.13218 14.0331 5.83041 13.8692 5.64935Z"}));
}

IconArrowOut.defaultProps = {"viewBox":"0 0 14 13","fill":"none"};

module.exports = IconArrowOut;

IconArrowOut.default = IconArrowOut;
